//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/SelectBody.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
let d=[[[1,"BendAngle",0,"Expression",0],[1,"BendRadius",0,"Expression",0],[1,"FoldLocation",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"FoldRotationAngle",0,"Expression",0],[1,"FoldStartRotationAngle",0,"Expression",0],[1,"LengthAdjustment",0,"Expression",0],[0,"ReverseBendAngle",1,0],[0,"ReverseFixedSegment",1,0],[0,"ReverseFoldRotationAngle",1,0],[0,"Spline",0,"Curve",0],[1,"StockSelection",0,"SelectBody",0]],[[["stock"],"SetStock",{},1,0]],[]];
SPLM.Routing.RouteSweptFoldBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.RouteSweptFoldBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;